import { useCallback, useEffect, useState } from "react";
import { Column, DetailPage, Row } from "../../components/crud/DetailPage"
import { Badge, FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, DateInput, EmailInput, ImageInput, MoneyInput, NumberInput, PhoneInput, Select, TextareaInput, TextInput, toDateOnly } from "../../components/forms/Inputs"
import { TvaInput, useRegimeTvaOptions } from "./Clients"
import { useLangueOptions } from "./Gerants"
import { OffreDetailsList } from "./OffresDetail"
import { Popup } from "../../components/layout/Popup";
import { Form } from "../../components/forms/Form";
import { useOptions } from "../../hooks/useOptions";
import { FaBan, FaPaintBrush } from "react-icons/fa";
import { useApi } from "../../hooks/useApi";
import { Button } from "../../components/layout/Button";
import { useLocale, useTranslations } from "../../layers/Localization";
import { HistoriquesList } from "./Historique";
import { ContactsList, useTitleOptions } from "./Contacts";
import { useFonctionOptions } from "./Personnel";
import { postalCodeToCommune, roundCurrency } from "../../hooks/helpers";
import { useTypeOptions } from "./Chantiers";
import { SendSingleEmailPopup, useStatusEnvoiEmailOptions } from "./Factures";
import { debounce } from "lodash";
import { useParams } from "react-router-dom";
import { useToday } from "../../hooks/useToday";
import { useSociete } from "../../hooks/useSociete";

const concerneOptions = [
    { value: "Le nettoyage des communs de votre immeuble situé :", label: "Le nettoyage des communs de votre immeuble situé :" },
    { value: "Le nettoyage de vos bureaux situés :", label: "Le nettoyage de vos bureaux situés :" },
    { value: "Le nettoyage des vitres de votre immeuble situé :", label: "Le nettoyage des vitres de votre immeuble situé :" },
    { value: "Le nettoyage des vitres de vos bureaux situés :", label: "Le nettoyage des vitres de vos bureaux situés :" },
    { value: "Het schoonmaken van Uw kantoren gelegen te :", label: "Het schoonmaken van Uw kantoren gelegen te :" },
    { value: "La cristallisation du sol du hall d'entrée de votre immeuble situé :", label: "La cristallisation du sol du hall d'entrée de votre immeuble situé :" },
    { value: "Het schoonmaken van de gemeenschappelijke gedeelten van het gebouw gelegen te :", label: "Het schoonmaken van de gemeenschappelijke gedeelten van het gebouw gelegen te :" },
    { value: "Avenant au contrat de nettoyage qui nous lie.", label: "Avenant au contrat de nettoyage qui nous lie." },
    { value: "Het reinigen van het tapijt in uw lokalen gelegen te :", label: "Het reinigen van het tapijt in uw lokalen gelegen te :" },
    { value: "Het reinigen van de ramen van uw kantoren gelegen te :", label: "Het reinigen van de ramen van uw kantoren gelegen te :" },
    { value: "Le nettoyage des tapis vos bureaux situé :", label: "Le nettoyage des tapis vos bureaux situé :" },
    { value: "Het reinigen van het tapijt van uw kantoren gelegen te :", label: "Het reinigen van het tapijt van uw kantoren gelegen te :" },
    { value: "Le remplacement de votre concierge de l'immeuble situé:", label: "Le remplacement de votre concierge de l'immeuble situé:" },
    { value: "Le nettoyage après déménagement de votre maison située :", label: "Le nettoyage après déménagement de votre maison située :" },
    { value: "The cleaning of your offices.", label: "The cleaning of your offices." },
]

const useActions = (setApplyModeleOffreId, setOffre, setSingleEmailPopup, setReload) => {
    const t = useTranslations()
    const api = useApi()

    return {
        [t('Aperçu offre')]: item => window.open(`${process.env.REACT_APP_API_URL}/offres/${item.id}/pdf`, '_blank').focus(),
        [t('Dupliquer')]: (item, reload) => api.post(`/offres/${item.id}/duplicate`).then(reload),
        [t('Appliquer modele')]: item => setApplyModeleOffreId(item.id),
        [t('Envoyer email')]: (item, reload) => {
            setOffre(item)
            setSingleEmailPopup(true)
            setReload(() => reload)
        }
    }
}

function OffreFields({ item, set, tab }) {
    const t = useTranslations()
    const { id } = useParams()
    const [locale] = useLocale()
    const [client, setClient] = useState()
    const [gerant, setGerant] = useState()
    const [concerne, setConcerne] = useState()
    const [chantierConcurrent, setChantierConcurrent] = useState()
    const [offreDetail, setOffreDetail] = useState([])
    const clientOptions = useOptions('clients', 'referenceCourte', { query: 'gerant:join=nom' })
    const gerantOptions = useOptions('gerants', 'nom')
    const contactOptions = useOptions('contacts', ['nom', 'fonction'], { query: [client ? `or2:clientId=${client.id}` : '', client?.gerantId ? `or2:gerantId=${client.gerantId}` : '', gerant ? `or2:gerantId=${gerant.id}` : ''].join('&') })
    const personnelOptions = useOptions('personnel', ['prenom', 'nom'], { query: 'signataire=true', label: x => `${x.prenom || ''} ${x.nom || ''} (${x.fonction})` })
    const frequencesOptions = useOptions('frequences', locale === 'fr' ? 'textFr' : locale === 'nl' ? 'textNl' : 'textEn')
    const typeOptions = useTypeOptions()
    const langueOptions = useLangueOptions()
    const titreOptions = useTitleOptions()
    const regimeTvaOptions = useRegimeTvaOptions()
    const fonctionOptions = useFonctionOptions()
    const api = useApi()
    const societe = useSociete()

    const totalHours = id === 'new' ? null : roundCurrency(offreDetail.reduce((total, item) => total += ((item.temps || 0) * (item.qte || 0) * (item.frequence?.frequences || 0)), 0) / 60 / 4.33)

    useEffect(() => {
        if (id === 'new') api.get(`/offres?limit=1&orderBy:desc=num`).then(offres => set('num')(Number(offres[0]?.num || 0) + 1))
        if (id === 'new') setOffreDetail([])
        else api.get(`/offresDetail?offreId=${encodeURIComponent(id)}&frequence:join&limit=1000`).then(setOffreDetail)
    }, [id])
    useEffect(() => {
        if (id === 'new' && !item.clientRegimeTva) set('clientRegimeTva')('NON_ASSUJETTI_NORMAL')
    }, [id, item.clientRegimeTvaId])
    useEffect(() => {
        if (!item.id && societe) {
            if (!item.taux1) set('taux1')(societe.tauxParDefaut || null)
            if (!item.taux2) set('taux2')(societe.tauxParDefaut || null)
            if (!item.taux3) set('taux3')(societe.tauxParDefaut || null)
            if (!item.taux4) set('taux4')(societe.tauxParDefaut || null)
            if (!item.taux5) set('taux5')(societe.tauxParDefaut || null)
            if (!item.personnelId && societe.signataireParDefautId) {
                api.get(`/personnel/${societe.signataireParDefautId}`).then(item => {
                    set('personnelId')(item.id || null)
                    set('personnelNom')(item.nom || null)
                    set('personnelPrenom')(item.prenom || null)
                    set('personnelFonction')(item.fonction || null)
                })
            }
        }
        if (item.langue && societe) {
            if (item.langue === 'FR') {
                if (!item.comprendBien) set('comprendBien')(societe.comprendBienFr || '')
                if (!item.comprendPas) set('comprendPas')(societe.comprendPasFr || '')
                if (!item.concerne) set('concerne')(societe.concerneFr || '')
                if (!item.forfait1Pour) set('forfait1Pour')(societe.forfait1PourFr || '')
            } else if (item.langue === 'NL') {
                if (!item.comprendBien) set('comprendBien')(societe.comprendBienNl || '')
                if (!item.comprendPas) set('comprendPas')(societe.comprendPasNl || '')
                if (!item.concerne) set('concerne')(societe.concerneNl || '')
                if (!item.forfait1Pour) set('forfait1Pour')(societe.forfait1PourNl || '')
            } else if (item.langue === 'EN') {
                if (!item.comprendBien) set('comprendBien')(societe.comprendBienEn || '')
                if (!item.comprendPas) set('comprendPas')(societe.comprendPasEn || '')
                if (!item.concerne) set('concerne')(societe.concerneEn || '')
                if (!item.forfait1Pour) set('forfait1Pour')(societe.forfait1PourEn || '')
            }
        }
    }, [item.id, item.langue, societe])

    const debouncedGetChantierConcurrent = useCallback(debounce(url => {
        api.get(url).then(items => setChantierConcurrent(items[0]))
    }, 200, { leading: false, trailing: true }), [])

    useEffect(() => {
        if (item.clientNumTva && item.date) {
            const url = `/chantiersConcurrents?` + [
                `numTva=${encodeURIComponent(item.clientNumTva)}`,
                `or:dateFin=`,
                `or:dateFin:gte=${encodeURIComponent(item.date.toISOString())}`,
            ].filter(x => x).join('&')
            debouncedGetChantierConcurrent(url)
        } else setChantierConcurrent(null)
    }, [item.clientNumTva, item.date])

    const onPersonnelChange = (id, item) => {
        set('personnelId')(id)
        if (item) {
            set('personnelNom')(item.nom)
            set('personnelPrenom')(item.prenom)
            set('personnelFonction')(item.fonction)
        }
    }
    const onClientChange = (id, item) => {
        set('clientId')(id)
        setClient(item)
        if (item) {
            set('gerantNom')(item.gerant?.nom)
            set('clientNom')(item.nom)
            set('clientReferenceCourte')(item.referenceCourte)
            set('clientNumTva')(item.numTva)
            set('clientRegimeTva')(item.regimeTva)
            set('clientEmailFacturation')(item.emailFacturation)
            set('clientEmailRappels')(item.emailRappels)
            set('clientAdresse')(item.adresse)
            set('clientCp')(item.cp)
            set('clientCommune')(item.commune)
            set('gerantAdresse')(item.gerant?.adresse)
            set('gerantCp')(item.gerant?.cp)
            set('gerantCommune')(item.gerant?.commune)
            set('gerantNumTva')(item.gerant?.numTva)
            set('gerantEmailFacturation')(item.gerant?.emailFacturation)
            set('gerantEmailRappels')(item.gerant?.emailRappels)
        }
    }
    const onGerantChange = (id, item) => {
        set('gerantId')(id)
        if (item) {
            set('gerantNom')(item.nom)
            set('gerantAdresse')(item.adresse)
            set('gerantCp')(item.cp)
            set('gerantCommune')(item.commune)
            set('gerantNumTva')(item.numTva)
            set('gerantEmailFacturation')(item.emailFacturation)
            set('gerantEmailRappels')(item.emailRappels)
        }
    }
    const onContactChange = (id, item) => {
        set('contactId')(id)
        if (item) {
            set('contactTitre')(item.titre)
            set('contactNom')(item.nom)
            set('contactEmail')(item.email)
            set('contactTel')(item.tel)
            set('contactFonction')(item.fonction)
        }
    }
    const onSearchConcerneChange = value => {
        setConcerne(value)
        set('concerne')(value)
    }
    const onConcerneChange = value => {
        set('concerne')(value)
        if (!concerneOptions.map(x => x.value).includes(item.concerne)) setConcerne(null)
    }
    const onClientCodePostalChange = value => {
        set('clientCp')(value)
        if (!item.clientCommune && postalCodeToCommune(value)) set('clientCommune')(postalCodeToCommune(value))
    }
    const onGerantCodePostalChange = value => {
        set('gerantCp')(value)
        if (!item.gerantCommune && postalCodeToCommune(value)) set('gerantCommune')(postalCodeToCommune(value))
    }

    if (tab === t('Données')) return <>
        <Row>
            <NumberInput label={t("Numéro")} value={item.num} onChange={set('num')} required max="999999" />
            <Select label={t("Type de devis")} value={item.typeDevis} onChange={set('typeDevis')} options={typeOptions} required />
            <Select label={t("Langue")} value={item.langue} onChange={set('langue')} options={langueOptions} required />
        </Row>
        <Row>
            <DateInput label={t("Date")} value={item.date} onChange={set('date')} required />
            <TextInput className="grow" label={t("Référence de l'offre")} value={item.reference} onChange={set('reference')} required />
        </Row>
        <hr />
        <h3 className="font-bold text-lg underline">{t("Client")}</h3>
        <Row>
            <AsyncSelect className="grow" label={t("Chercher client")} value={item.clientId} onChange={onClientChange} options={clientOptions} onItemLoad={setClient} />
            <TextInput className="grow" label={t("Nom du client")} value={item.clientNom} onChange={set('clientNom')} />
            <TextInput label={t("Référence courte du client")} value={item.clientReferenceCourte} onChange={set('clientReferenceCourte')} />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Adresse client")} value={item.clientAdresse} onChange={set('clientAdresse')} />
            <TextInput label={t("Code postal client")} value={item.clientCp} onChange={onClientCodePostalChange} min="1000" max="9999" />
            <TextInput label={t("Commune client")} value={item.clientCommune} onChange={set('clientCommune')} />
        </Row>
        <Row>
            <TvaInput label={t("Numéro de TVA du client")} value={item.clientNumTva} onChange={set('clientNumTva')} />
            <Select label={t("Régime TVA du client")} value={item.clientRegimeTva} onChange={set('clientRegimeTva')} options={regimeTvaOptions} />
        </Row>
        <Row>
            <EmailInput className="grow" label={t("Email de facturation du client")} value={item.clientEmailFacturation} onChange={set('clientEmailFacturation')} />
            <EmailInput className="grow" label={t("Email de rappels du client")} value={item.clientEmailRappels} onChange={set('clientEmailRappels')} />
        </Row>
        {chantierConcurrent && <div className="flex gap-2 font-bold">
            <div className="text-red-500">{t("Ce chantier est non-concurrençable:")}</div>
            <FkLink to={`/chantiersConcurrents/${chantierConcurrent.id}`}>{chantierConcurrent.nom}</FkLink>
        </div>}
        <hr />
        <h3 className="font-bold text-lg underline">{t("Gérant")}</h3>
        <Row>
            <AsyncSelect label={t("Chercher gérant")} value={item.gerantId} onChange={onGerantChange} options={gerantOptions} onItemLoad={setGerant} />
            <TextInput label={t("Nom du gérant")} value={item.gerantNom} onChange={set('gerantNom')} />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Adresse gérant")} value={item.gerantAdresse} onChange={set('gerantAdresse')} />
            <TextInput label={t("Code postal gérant")} value={item.gerantCp} onChange={onGerantCodePostalChange} />
            <TextInput label={t("Commune gérant")} value={item.gerantCommune} onChange={set('gerantCommune')} />
        </Row>
        <Row>
            <TvaInput label={t("Numéro de TVA du gérant")} value={item.gerantNumTva} onChange={set('gerantNumTva')} />
            <EmailInput className="grow" label={t("Email de facturation du gérant")} value={item.gerantEmailFacturation} onChange={set('gerantEmailFacturation')} />
            <EmailInput className="grow" label={t("Email de rappels du gérant")} value={item.gerantEmailRappels} onChange={set('gerantEmailRappels')} />
        </Row>
        <hr />
        <h3 className="font-bold text-lg underline">{t("Destinataire")}</h3>
        <Row>
            <AsyncSelect label={t("Chercher destinataire")} value={item.contactId} onChange={onContactChange} options={contactOptions} />
            <Select label={t("Titre du destinataire")} value={item.contactTitre} onChange={set('contactTitre')} options={titreOptions} />
            <TextInput className="grow" label={t("Nom du destinataire")} value={item.contactNom} onChange={set('contactNom')} />
            <TextInput label={t("Fonction du destinataire")} value={item.contactFonction} onChange={set('contactFonction')} />
        </Row>
        <Row>
            <EmailInput label={t("Email du destinataire")} value={item.contactEmail} onChange={set('contactEmail')} />
            <PhoneInput label={t("Téléphone du destinataire")} value={item.contactTel} onChange={set('contactTel')} />
            <PhoneInput label={t("GSM du destinataire")} value={item.contactMobilophone} onChange={set('contactMobilophone')} />
        </Row>
        <hr />
        <h3 className="font-bold text-lg">{t("Mémo interne")}</h3>
        <TextareaInput className="[&_textarea]:text-red-600" label={t("Mémo interne offre")} value={item.memoInterneOffre} onChange={set('memoInterneOffre')} />
    </>

    if (tab === t('Textes')) return <>
        <Row start>
            <ImageInput label={t("Photo")} value={item.photo} onChange={set('photo')} />
            <Column>
                <Select label={t("Chercher concerne")} value={concerne} onChange={onSearchConcerneChange} options={concerneOptions} />
                <TextInput className="grow" label={t("Concerne")} value={item.concerne} onChange={onConcerneChange} />
            </Column>
        </Row>
        <TextareaInput label={t("Comprend")} value={item.comprendBien} onChange={set('comprendBien')} required />
        <TextareaInput label={t("Ne comprend pas")} value={item.comprendPas} onChange={set('comprendPas')} />
        <Checkbox label={t("Contrat récurrent")} value={item.contratRecurrent} onChange={set('contratRecurrent')} />
        <Row>
            <AsyncSelect label={t("Chercher signataire")} value={item.personnelId} onChange={onPersonnelChange} options={personnelOptions} required />
            <TextInput label={t("Prénom du signataire")} value={item.personnelPrenom} onChange={set('personnelPrenom')} required />
            <TextInput label={t("Nom du signataire")} value={item.personnelNom} onChange={set('personnelNom')} required />
            <Select label={t("Fonction du signataire")} value={item.personnelFonction} onChange={set('personnelFonction')} options={fonctionOptions} required />
        </Row>
        <TextareaInput label={t("Conditions particulières")} value={item.conditionsParticulieres} onChange={set('conditionsParticulieres')} />
    </>

    if (tab === t('Prix')) return <>
        <TextInput className="grow" label={t("Forfait pour")} value={item.forfait1Pour} onChange={set('forfait1Pour')} required />
        <Row>
            <AsyncSelect label={t("Fréquence")} value={item.frequence1Id} onChange={set('frequence1Id')} options={frequencesOptions} />
            <NumberInput label={t("Heures")} value={totalHours} max="999" step="0.01" disabled />
            <NumberInput label={t("Heures/semaine")} value={item.heures1} onChange={set('heures1')} max="999" step="0.01" />
            <MoneyInput label={t("Taux")} value={item.taux1} onChange={set('taux1')} max="999" />
            <MoneyInput label={t("Calcul")} value={item.heures1 && item.taux1 ? roundCurrency(item.heures1 * item.taux1 * 4.33) : null} max="99999" disabled />
            <MoneyInput label={t("Prix")} value={item.prix1} onChange={set('prix1')} max="99999" />
        </Row>
        {(item.forfait1Pour && item.prix1 != null) && <>
            <hr />
            <TextInput className="grow" label={t("Forfait pour")} value={item.forfait2Pour} onChange={set('forfait2Pour')} />
            <Row>
                <AsyncSelect label={t("Fréquence")} value={item.frequence2Id} onChange={set('frequence2Id')} options={frequencesOptions} />
                <NumberInput label={t("Heures")} value={totalHours} max="999" step="0.01" disabled />
                <NumberInput label={t("Heures/semaine")} value={item.heures2} onChange={set('heures2')} max="999" step="0.01" />
                <MoneyInput label={t("Taux")} value={item.taux2} onChange={set('taux2')} max="999" />
                <MoneyInput label={t("Calcul")} value={item.heures2 && item.taux2 ? roundCurrency(item.heures2 * item.taux2 * 4.33) : null} max="99999" disabled />
                <MoneyInput label={t("Prix")} value={item.prix2} onChange={set('prix2')} max="99999" />
            </Row>
        </>}
        {(item.forfait2Pour && item.prix2 != null) && <>
            <hr />
            <TextInput className="grow" label={t("Forfait pour")} value={item.forfait3Pour} onChange={set('forfait3Pour')} />
            <Row>
                <AsyncSelect label={t("Fréquence")} value={item.frequence3Id} onChange={set('frequence3Id')} options={frequencesOptions} />
                <NumberInput label={t("Heures")} value={totalHours} max="999" step="0.01" disabled />
                <NumberInput label={t("Heures/semaine")} value={item.heures3} onChange={set('heures3')} max="999" step="0.01" />
                <MoneyInput label={t("Taux")} value={item.taux3} onChange={set('taux3')} max="999" />
                <MoneyInput label={t("Calcul")} value={item.heures3 && item.taux3 ? roundCurrency(item.heures3 * item.taux3 * 4.33) : null} max="99999" disabled />
                <MoneyInput label={t("Prix")} value={item.prix3} onChange={set('prix3')} max="99999" />
            </Row>
        </>}
        {(item.forfait3Pour && item.prix3 != null) && <>
            <hr />
            <TextInput className="grow" label={t("Forfait pour")} value={item.forfait4Pour} onChange={set('forfait4Pour')} />
            <Row>
                <AsyncSelect label={t("Fréquence")} value={item.frequence4Id} onChange={set('frequence4Id')} options={frequencesOptions} />
                <NumberInput label={t("Heures")} value={totalHours} max="999" step="0.01" disabled />
                <NumberInput label={t("Heures/semaine")} value={item.heures4} onChange={set('heures4')} max="999" step="0.01" />
                <MoneyInput label={t("Taux")} value={item.taux4} onChange={set('taux4')} max="999" />
                <MoneyInput label={t("Calcul")} value={item.heures4 && item.taux4 ? roundCurrency(item.heures4 * item.taux4 * 4.33) : null} max="99999" disabled />
                <MoneyInput label={t("Prix")} value={item.prix4} onChange={set('prix4')} max="99999" />
            </Row>
        </>}
        {(item.forfait4Pour && item.prix4 != null) && <>
            <hr />
            <TextInput className="grow" label={t("Forfait pour")} value={item.forfait5Pour} onChange={set('forfait5Pour')} />
            <Row>
                <AsyncSelect label={t("Fréquence")} value={item.frequence5Id} onChange={set('frequence5Id')} options={frequencesOptions} />
                <NumberInput label={t("Heures")} value={totalHours} max="999" step="0.01" disabled />
                <NumberInput label={t("Heures/semaine")} value={item.heures5} onChange={set('heures5')} max="999" step="0.01" />
                <MoneyInput label={t("Taux")} value={item.taux5} onChange={set('taux5')} max="999" />
                <MoneyInput label={t("Calcul")} value={item.heures5 && item.taux5 ? roundCurrency(item.heures5 * item.taux5 * 4.33) : null} max="99999" disabled />
                <MoneyInput label={t("Prix")} value={item.prix5} onChange={set('prix5')} max="99999" />
            </Row>
        </>}
        <hr />
        <TextareaInput className="[&_textarea]:text-red-600" label={t("Mémo interne prix")} value={item.memoInternePrix} onChange={set('memoInternePrix')} />
    </>
}

export function OffresList(props) {
    const [applyModeleOffreId, setApplyModeleOffreId] = useState(false)
    const [offre, setOffre] = useState()
    const [singleEmailPopup, setSingleEmailPopup] = useState(false)
    const [reload, setReload] = useState(false)
    const t = useTranslations()
    const actions = useActions(setApplyModeleOffreId, setOffre, setSingleEmailPopup, setReload)
    const statusEnvoiEmailOptions = useStatusEnvoiEmailOptions()

    return <>
        <ListPage model="offres" title={t("Offres")} columns={{
            [t("Numéro")]: 'num',
            [t('Date')]: 'date',
            [t('Référence')]: 'reference',
            [t('Signataire')]: { sort: 'personnel', value: item => <FkLink>{`${item.personnel?.prenom} ${item.personnel?.nom || ''}`}</FkLink> },
            [t('Email')]: { sort: 'statusEnvoiEmail', value: item => <Badge value={item?.statusEnvoiEmail} options={statusEnvoiEmailOptions} /> },
        }} sort={{
            [t('Numéro')]: 'desc',
        }} join={{
            personnel: ['prenom', 'nom'],
        }} actions={actions} {...props} />
        <ApplyModelePopup offreId={applyModeleOffreId} setOffreId={setApplyModeleOffreId} />
        <SendSingleEmailPopup value={singleEmailPopup} onChange={setSingleEmailPopup} model="offres" item={offre} reload={reload} />
    </>
}

export function OffreDetail(props) {
    const [applyModeleOffreId, setApplyModeleOffreId] = useState(false)
    const [offre, setOffre] = useState()
    const [singleEmailPopup, setSingleEmailPopup] = useState(false)
    const [reload, setReload] = useState(false)
    const t = useTranslations()
    const actions = useActions(setApplyModeleOffreId, setOffre, setSingleEmailPopup, setReload)

    const today = useToday()

    return <>
        <DetailPage model="offres" title={t("Offre")} Fields={OffreFields} actions={actions}
            tabs={[t('Données'), t('Textes'), t('Prix')]} nextKey="num" tables={{
                [t("Détails")]: <OffreDetailsList relation="offreId" root="." />,
                [t("Historique")]: <HistoriquesList relation="offreId" root="." />,
                [t("Contacts")]: <ContactsList relation="offreId" root="." />,
            }} defaults={{
                date: toDateOnly(new Date(today)),
                concerne: concerneOptions[0].value,
                contratRecurrent: true
            }} {...props} />
        <ApplyModelePopup offreId={applyModeleOffreId} setOffreId={setApplyModeleOffreId} />
        <SendSingleEmailPopup value={singleEmailPopup} onChange={setSingleEmailPopup} model="offres" item={offre} reload={reload} />
    </>
}

function ApplyModelePopup({ offreId, setOffreId }) {
    const [modeleId, setModeleId] = useState(null)

    const modeleOptions = useOptions('offreModele', 'nom')
    const api = useApi()
    const t = useTranslations()

    const reset = () => {
        setOffreId(false)
        setModeleId(null)
    }
    const apply = async () => {
        reset()
        await api.post(`/offres/${offreId}/apply-modele`, { modele: modeleId })
        window.location.reload()
    }

    return <Popup value={!!offreId} onChange={setOffreId}>
        <Form onSubmit={apply}>
            <h2 className="text-xl mb-3">{t("Quel modèle désirez-vous appliquer ?")}</h2>
            <div className="mb-8">{t("Attention ! Toutes les données existantes seront écrasées !")}</div>
            <AsyncSelect value={modeleId} onChange={setModeleId} options={modeleOptions} required className="mb-8" />
            <div className="flex gap-3">
                <Button gray icon={<FaBan />} onClick={reset}>{t("Annuler")}</Button>
                <Button icon={<FaPaintBrush />} submit>{t("Appliquer")}</Button>
            </div>
        </Form>
    </Popup>
}